import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ORDER_METHODS, REDUX_STORE_SLICES } from '../../services/exports/Constants';
import { DeliveryAddressSchema } from '../../modules/mobile/modals/delivery-address/form/schema';
import { SliceCaseReducers } from '@reduxjs/toolkit/dist/createSlice';
import { StoreInterface } from '../types';

export interface OrderMethodState {
  scheduledFor: string;
  orderMethod: ORDER_METHODS;
  deliveryData: DeliveryAddressSchema;
}

const initialState: OrderMethodState = {
  scheduledFor: null,
  orderMethod: null,
  deliveryData: null,
};

const orderMethodSlice = createSlice<OrderMethodState, SliceCaseReducers<OrderMethodState>>({
  name: REDUX_STORE_SLICES.ORDER_METHOD,
  initialState,
  reducers: {
    setOrderMethod: (state: OrderMethodState, action: PayloadAction<ORDER_METHODS>): void => {
      state.orderMethod = action.payload;
    },
    setScheduledFor: (state: OrderMethodState, action: PayloadAction<string>): void => {
      state.scheduledFor = action.payload;
    },
    setInitState: (state: OrderMethodState, action: PayloadAction<OrderMethodState>): void => {
      Object.assign(state, action.payload);
    },
    setDeliveryData: (state: OrderMethodState, action: PayloadAction<DeliveryAddressSchema>): void => {
      state.deliveryData = action.payload;
    },
    reset: (state: OrderMethodState): void => {
      Object.assign(state, initialState);
    },
  },
});

export default orderMethodSlice;

export const { setOrderMethod, setScheduledFor, setInitState, setDeliveryData } = orderMethodSlice.actions;
export const selectOrderMethodModalData = (state: StoreInterface) => state[REDUX_STORE_SLICES.ORDER_METHOD];
export const selectOrderMethodModalDataScheduledFor = (state: StoreInterface) =>
  state[REDUX_STORE_SLICES.ORDER_METHOD].scheduledFor;
export const selectOrderMethodModalDataDeliveryData = (state: StoreInterface) =>
  state[REDUX_STORE_SLICES.ORDER_METHOD].deliveryData;
